<template>
    <div>
        <div class="row align-items-center py-2">
            <div class="col-4 mx-auto">
                <div class="col-sm  mx-auto">{{$t('my_analysis.collection_set_no')}}: {{user.registration_code}}</div>
                <div class="col-sm  mx-auto">{{$t('my_analysis.registration_date')}}: {{user.date_registered}}</div>
            </div>
        </div>
        <div class="row align-items-center py-2">
            <div class="col-4  mx-auto">
                <button class="btn btn-primary" >{{$t('my_analysis.add_new_collection_set')}}</button>
            </div>
        </div>
        <div class="row align-items-center">
            <div class="col-3  mx-auto py-5">
                <h4>{{$t('change_password')}}</h4>
                <form>
                    <div class="form-group">
                        <label for="exampleInputPassword1">{{$t('password')}}</label>
                        <input type="password" class="form-control" id="exampleInputPassword1" placeholder="Password">
                    </div>
                    <div class="form-group">
                        <label for="exampleInputEmail1">{{$t('password_confirm')}}</label>
                        <input type="password" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"
                            placeholder="Enter email">
                    </div>
                    <button type="button" class="btn btn-primary" @click="changePassword">{{$t('change_password')}}</button>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import {DISPLAY_MESSAGE} from "../store/actions";

    export default {
        name: "MyAccount",
        computed: {
            ...mapGetters(['user']),
        },
        methods: {
            changePassword: function () {
                this.$store.dispatch(DISPLAY_MESSAGE, {
                    message: {
                        type: 'success',
                        content: 'Hasło zostało prawidłowo zmienione'
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/MyAccount.vue